import { render, staticRenderFns } from "./SaPhoneSheet.vue?vue&type=template&id=ab5b8276&scoped=true"
import script from "./SaPhoneSheet.vue?vue&type=script&lang=js"
export * from "./SaPhoneSheet.vue?vue&type=script&lang=js"
import style0 from "./SaPhoneSheet.vue?vue&type=style&index=0&id=ab5b8276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5b8276",
  null
  
)

export default component.exports